import Wizard from "components/wizard/Wizard";
import { ACTIVATION_TYPES } from "utils/constants";

const initialData = {
    subtype: "standard",
    name: null,
    email: null,
    phone1: null,
    phone2: null,
    mobile: null,
    commercial_reference: null,
    technical_reference: null,
    address: null,
    city: null,
    province: null,
    zip_code: null,
    country: "ITALY",
    description: null,
    licenses: [],
    total: 0,
    maintenance: 0,
    maintenance_data: {},
    maintenance_skip: false,
    fqdn: null,
    ip_fqdn: null,
    server_code: null,
    server_code_backup: null,
    ip_server: null,
    ip_server_backup: null,
    mac_addresses: {
        eth0: "",
        eth1: "",
        eth2: "",
        eth3: "",
        eth4: "",
    },
    mac_addresses_backup: {
        eth0: "",
        eth1: "",
        eth2: "",
        eth3: "",
        eth4: "",
    },
    size: "small",
    reseller_code: null,
    reseller_note: null,
};

const purchaseSteps = [2, 3, 4];

const stepsConfig = [
    {
        number: 1,
        summaryTitle: "Dati anagrafici",
    },
    {
        number: 2,
        summaryTitle: "Tipologia licenza",
    },
    {
        number: 3,
        summaryTitle: "Licenze",
    },
    {
        number: 4,
        summaryTitle: "Tipologia maintenance",
    },
    {
        number: 5,
        summaryTitle: "FQDN",
    },
    {
        number: 6,
        summaryTitle: "IP",
    },
    {
        number: 7,
        summaryTitle: "Server",
    },
];

const licenseTypesConfig = [
    {
        key: "standard",
    },
    {
        key: "channels",
    },
];

const Onsite = () => {
    return (
        <Wizard
            activationType={ACTIVATION_TYPES.ONSITE}
            initialData={initialData}
            stepsConfig={stepsConfig}
            licenseTypesConfig={licenseTypesConfig}
            purchaseSteps={purchaseSteps}
        />
    );
};

export default Onsite;
